import { Text, View } from '@react-pdf/renderer'
import { REPORT_COLORS } from 'pages/reporting/reports/rug/constants/rugReportStyles'
import type { useRugReportOps } from 'pages/reporting/reports/rug/RugReportProvider'
import React from 'react'
import { GeckoMeasurement } from 'types'

interface SectionStatsTextProps {
  sectionName: string
  minThickness: GeckoMeasurement
  averageThickness: GeckoMeasurement
  wallLossPercent?: GeckoMeasurement
  nominalThickness?: GeckoMeasurement
  componentName?: string
  formatMeasurement: ReturnType<typeof useRugReportOps>['formatMeasurement']
  showSectionName?: boolean
}

export const SectionStatsText: React.FC<SectionStatsTextProps> = ({
  componentName,
  formatMeasurement,
  sectionName,
  minThickness,
  averageThickness,
  wallLossPercent,
  nominalThickness,
  showSectionName = true,
}) => {
  return (
    <View wrap={false} style={{ marginBottom: 12 }}>
      {componentName && (
        <Text
          style={{
            fontSize: 10,
            fontWeight: 'bold',
            marginBottom: 6,
            color: REPORT_COLORS.HEADER_TEXT,
          }}>
          {componentName}
        </Text>
      )}
      {showSectionName && (
        <Text
          style={{
            fontSize: 10,
            fontWeight: 'medium',
            marginBottom: 4,
            color: REPORT_COLORS.HEADER_TEXT,
          }}>
          {sectionName}
        </Text>
      )}
      <View style={{ paddingLeft: 8 }}>
        <Text style={{ fontSize: 8, marginBottom: 4 }}>
          • The minimum thickness detected was{' '}
          {formatMeasurement({
            measurement: minThickness,
            variant: 'narrow',
            minimumFractionDigits: 3,
          })}{' '}
          with an average thickness of{' '}
          {formatMeasurement({
            measurement: averageThickness,
            variant: 'narrow',
            minimumFractionDigits: 3,
          })}
          .
        </Text>
        <Text style={{ fontSize: 8, marginBottom: 4 }}>
          • This minimum thickness represents a{' '}
          {formatMeasurement({
            measurement: wallLossPercent,
            variant: 'narrow',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) ?? 'N/A'}{' '}
          wall loss
          {nominalThickness
            ? ` from the nominal thickness of ${formatMeasurement({
                measurement: nominalThickness,
                variant: 'narrow',
                minimumFractionDigits: 3,
              })}`
            : ''}
          .
        </Text>
      </View>
    </View>
  )
}
